import { defineMessages } from 'react-intl';

export const errorTypeMsgs = defineMessages({
	info: {
		id: 'notification.types.info.label',
		defaultMessage: 'Внимание',
	},
	warning: {
		id: 'notification.types.warning.label',
		defaultMessage: 'Предупреждение',
	},
	error: {
		id: 'notification.types.error.label',
		defaultMessage: 'Ошибка',
	},
});
